// 自定义环状饼图 - 继承DOMOverlay
function Donut(options) {
  TMap.DOMOverlay.call(this, options);
}

Donut.prototype = new TMap.DOMOverlay();

// 初始化
Donut.prototype.onInit = function (options) {
  this.position = options.position;//覆盖物显示的位置
  this.data = options.data;//覆盖物文本内容
  this.isShowPickup = options.isShowPickup;//是否显示司机正在前往提货地，目前限制是距离提货时间1小时内才显示
  this.deliveryTime = options.deliveryTime;//提货时间 预约单才需要显示
  this.code = options.code;//当前物流节点编码
  this.offsetY = Number(options.offsetY) || 0;//覆盖物向上偏移量
};

// 销毁时需解绑事件监听
Donut.prototype.onDestroy = function () {
  if (this.onClick) {
    this.dom.removeEventListener(this.onClick);
  }
};

// 创建DOM元素，返回一个DOMElement，使用this.dom可以获取到这个元素
Donut.prototype.createDOM = function () {
  // 地图居中div
  let absoluteBox = document.createElement('div');
  absoluteBox.style.cssText = "position: absolute;width: 100%;display:flex;justify-content:center;";

  // 内容盒子div
  let contentBox = document.createElement('div');
  contentBox.style.cssText = "position: relative;";

  // 温湿度信息
  let temperatureEle = null;//订单温湿度节点
  if(this.data.temperature){
    // 存在订单温湿度才创建节点元素
    let temp = this.data.temperature.find(item=>item.sensorType === 'temperature');
    let humi = this.data.temperature.find(item=>item.sensorType === 'humidity');
    temperatureEle = document.createElement('div');
    temperatureEle.style.cssText = "position: relative;height: 32px;display:flex;justify-content:center;";
    temperatureEle.innerHTML = `
    <img src="${require('@/assets/image/temperature-tag.png')}" style="width:132px;height:100%;position:absolute;top:0;left:50%;z-index:1;transform: translateX(-50%);" alt="">
    <div style="width:132px;height:100%;padding:0 32px;box-sizing:border-box;z-index:2;position: relative;display:flex;justify-content: space-between;color:#ffffff;font-size:14px;align-items:center;">
      <span style="line-height:14px;">${temp?parseInt(temp.sensorValue/10)+'℃':''}</span>
      <span style="line-height:14px;">${humi?parseInt(humi.sensorValue/10)+'%':''}</span>
    </div>
    `
  }
  // 里程信息
  // 判断只有文本内容才创建节点
  let elementBox = null;
  if(Object.keys(this.data).includes('text')){
    elementBox = document.createElement('div');
    elementBox.style.cssText = "position: relative;height: 62px;";
    if(this.isShowPickup){
      elementBox.innerHTML = `
      <img src="${require('@/assets/image/popup-bg.png')}" style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;" alt="">
      <div style="padding: 8px;box-sizing: border-box;position: relative;z-index:2;">
        <div style="font-size:14px;line-height:20px;">${this.data.text}</div>
        <div style="display:flex;align-items:center;font-size:12px;">
          <span style="color:#85807B;">${this.data.contentText?this.data.contentText:'距您'}</span>
          <span style="color:#EC892E;margin-left:4px;">${this.data.meil}km</span>
          <span style="width:1px;height:12px;background-color:#C9C9C9;margin:0 5px;"></span>
          <span style="color:#EC892E;">${this.data.time}</span>
        </div>
      </div>
      `
    }else{
      const contentText = Object.prototype.hasOwnProperty.call(this.data, 'contentText')
        ? this.data.contentText
        : '提货时间';
      const deliveryColor = this.deliveryTime === '已超时' ? '#FF484A' : '#EC892E';
      // 装卸货操作阶段的气泡只展示状态和地址，不展示提货时间。
      const hideDeliveryTime = [
        'arriveDelivery', 'beginningLoading', 'completionLoading',
        'arriveUploads', 'arriveReceiving', 'breakBulk', 'completeDischarge'
      ].includes(this.code);
      elementBox.innerHTML = `
      <img src="${require('@/assets/image/popup-bg.png')}" style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;" alt="">
      <div style="padding: 8px;box-sizing: border-box;position: relative;z-index:2;">
        <div style="font-size:14px;line-height:20px;">${this.data.text}</div>
        <div style="display:flex;align-items:center;font-size:12px;" v-else>
          <span style="color:#85807B;margin-right:2px;">${contentText}</span>
          ${hideDeliveryTime ? '' : `<span style="color:${deliveryColor};">${this.deliveryTime}</span>`}
        </div>
      </div>
      `
    }
  }

  // // 里程信息
  // let imgElement = document.createElement('img');
  // imgElement.src = require("@/assets/image/popup-bg.png");
  // imgElement.style.cssText = "width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;";
  // elementBox.appendChild(imgElement);

  // let contentDiv = document.createElement('div');
  // contentDiv.style.cssText = "padding: 8px;box-sizing: border-box;position: relative;z-index:2;";
  // let childDiv = document.createElement('div');
  // childDiv.style.cssText = "font-size:14px;line-height:20px;";
  // childDiv.innerText = this.data.text;
  // let child2Div = document.createElement('div');
  // child2Div.style.cssText = "display:flex;align-items:center;font-size:12px;";
  // if(this.isShowPickup){
  //   child2Div.innerHTML = `<span style="color:#85807B;">距您</span>
  //           <span style="color:#EC892E;margin-left:4px;">${this.data.meil}km</span>
  //           <span style="width:1px;height:12px;background-color:#C9C9C9;margin:0 5px;"></span>
  //           <span style="color:#EC892E;">${this.data.time}</span>`
  // }else{
  //   child2Div.innerHTML = `<span style="color:#85807B;margin-right:2px;">提货时间</span>
  //           <span style="color:#EC892E;">${this.deliveryTime}</span>`
  // }
  // contentDiv.appendChild(childDiv);
  // contentDiv.appendChild(child2Div);
  if(temperatureEle)contentBox.appendChild(temperatureEle);
  if(elementBox)contentBox.appendChild(elementBox);
  absoluteBox.appendChild(contentBox);
  return absoluteBox;
};


// 更新DOM元素，在地图移动/缩放后执行
Donut.prototype.updateDOM = function () {
  if (!this.map) {
    return;
  }

  // 经纬度坐标转容器像素坐标
  let pixel = this.map.projectToContainer(this.position);

  // 使饼图中心点对齐经纬度坐标点
  let left = pixel.getX() - this.dom.clientWidth / 2 + "px";
  let top = pixel.getY() - this.dom.clientHeight - 20 - this.offsetY + "px";
  this.dom.style.transform = `translate(${left}, ${top})`;
};

export default Donut;